 /* eslint-disable jsx-a11y/anchor-is-valid */
export default function Footer() {
    return (
        <footer className="foo">
            <p>Created by <a href="https://github.com/sourabhsahu33" target="_blank" rel="noopener noreferrer"> Sourabh⭐</a></p>
        </footer>
    )
}
 